import { BASE_URL, requestOptionsGET } from '@/utils/Constants';
import { useAuthStore } from '@/utils/stores/useAuthStore';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export function useUploadClassicDoc() {
  const { auth } = useAuthStore();
  const userId = auth.userId;
  const idToken = auth.idToken;

  return useMutation({
    mutationFn: async (file: File) => {
      if (!userId || !idToken) throw new Error('Unauthorized');

      const filename = file.name;
      const fileType = file.type;

      // Get S3 signed upload URL
      const response = await fetch(
        `${BASE_URL}/api/health-plans/user/${userId}/upload-url?filename=${encodeURIComponent(filename)}&folder=from_user&content_type=${encodeURIComponent(fileType)}`,
        requestOptionsGET(idToken)
      );

      if (!response.ok) {
        throw new Error('Error fetching upload URL');
      }

      const urlResponse = await response.json();

      // Prepare form data for S3
      const formData = new FormData();
      Object.entries(urlResponse.fields).forEach(([k, v]) => {
        formData.append(k, v as string);
      });
      formData.append('file', file);

      // Upload to S3
      const s3response = await axios.post(urlResponse.url, formData);

      if (s3response.status !== 204) {
        throw new Error('Failed to upload file to S3');
      }

      return true;
    },
  });
}